<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <b-form @submit.prevent="handleSubmit(AGResetUserPassword)">
      <b-row class="justify-content-center my-5">
        <b-col cols="12" sm="7" class="mb-3">
          <label>Veuillez définir un mot de passe :</label>
          <ValidationProvider
            v-slot="{ errors, classes }"
            :name="'mot de passe'"
            rules="required|min:4|confirmed:confirm"
            vid="confirm"
            tag="div"
            mode="passive"
          >
            <div class="password-input-wrapper">
              <b-input v-model="password" autofocus :type="inputType1" />
              <font-awesome-icon
                :icon="inputType1 == 'password' ? 'eye-slash' : 'eye'"
                @click="
                  inputType1 == 'password' ? (inputType1 = 'text') : (inputType1 = 'password')
                "
              />
            </div>

            <span :class="classes">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
        <b-col cols="12" sm="7">
          <label>Vérification mot de passe :</label>
          <!-- You can use vid or name to specify a targetable field -->
          <ValidationProvider
            v-slot="{ errors, classes }"
            :name="'confirmer le mot de passe'"
            rules="required|confirmed:confirm"
            tag="div"
            mode="passive"
          >
            <div class="password-input-wrapper">
              <b-input v-model="passwordConfirm" :type="inputType2" />
              <font-awesome-icon
                :icon="inputType2 == 'password' ? 'eye-slash' : 'eye'"
                @click="
                  inputType2 == 'password' ? (inputType2 = 'text') : (inputType2 = 'password')
                "
              />
            </div>
            <span :class="classes">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col class="d-flex justify-content-center">
          <b-button :disabled="isLoading" type="submit" class="button btn-blue">
            <font-awesome-icon v-if="!isLoading" class="agv-button-icon" icon="check" />
            <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
            <span>Réinitialiser</span>
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </ValidationObserver>
</template>

<script>
import BuildingOwnerORM from "@/store/orm-axios/models/BuildingOwner";
import ContactORM from "@/store/orm-axios/models/Contact";
import MeetingGuestORM from "@/store/orm-axios/models/MeetingGuest";

export default {
  props: {
    username: {
      type: String,
      required: true,
    },
    userType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      password: "",
      passwordConfirm: "",
      inputType1: "password",
      inputType2: "password",
    };
  },
  methods: {
    close() {
      this.$emit("closeModal");
    },
    AGResetUserPassword() {
      this.isLoading = true;

      this.$store
        .dispatch("auth/AGResetUserPassword", {
          username: this.username,
          userType: this.userType,
          password: this.password,
        })
        .then(() => {
          this.isLoading = false;
          this.userPasswordReseted();
        })
        .catch(err => {
          this.isLoading = false;
          console.error(err);
          this.$swal(this.alertError());
        });
    },
    userPasswordReseted() {
      var ModelORM = null;
      if (this.userType == "building-owner") {
        ModelORM = BuildingOwnerORM;
      } else if (this.userType == "contact") {
        ModelORM = ContactORM;
      } else if (this.userType == "meeting-guest") {
        ModelORM = MeetingGuestORM;
      }
      if (ModelORM)
        ModelORM.update({
          where: user => {
            return user.username == this.username;
          },
          data: { password: this.password },
        });

      this.$emit("userPasswordReseted");
    },
  },
};
</script>
